/* eslint-disable max-len */
import MemberItem from '@/components/conversation-insights/member-item';
import MemberItemLoader from '@/components/conversation-insights/member-item-loader';
// import { Select } from '@material-ui/core';
// import { SelectTrigger, SelectValue, SelectContent, SelectItem } from '@radix-ui/react-select';
import { ArrowUpIcon, ArrowDownIcon, Loader2 } from 'lucide-react';
import React, { useState } from 'react'
// import { Button } from 'react-day-picker';
import LeaderboardError from '@/components/conversation-insights/leaderboard-error';
import { FilterProps, Member, Option } from '@/utils/types';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Select, SelectTrigger, SelectContent, SelectValue, SelectItem } from '../ui/select';


type TeamMemberListProps = {
    filterProps: FilterProps;
    memberList: Member[];
    memberListLoading: boolean;
    memberListAPIError: boolean;
    filters: {[key:string]: string}[];
    noDataFetch: boolean;
    workspaceUsersObj: {[key:string]: Option};
    insightsFilters: any;
    handleLeaderboardUserClick: Function;
    handleLeaderboardUserRemove: Function;
}

const TeamMemberList = ({
    filterProps,
    workspaceUsersObj,
    memberList,
    memberListLoading,
    memberListAPIError,
    filters,
    noDataFetch,
    insightsFilters,
    handleLeaderboardUserClick,
    handleLeaderboardUserRemove,
  }: TeamMemberListProps) => {
  
    const [isPageIncrement, setIsPageIncrement] = useState<boolean>(false);
  
    if (memberListAPIError) {
      return <LeaderboardError />
    }
  
    return (
      <div className="p-4 w-full flex-1">
        <div className="w-full h-full flex flex-col">
          <div className="rounded-t-[12px] p-3 flex items-center justify-between">
              <p className="text-[#505056] text-xs">Last 7 days</p>
            <div className="flex items-center gap-1">
              <Button
                variant="outline"
                size="icon"
                className="border-0 bg-transparent hover:bg-transparent p-1 cursor-pointer rounded hover:bg-gray-100 h-fit"
                style={{ gap: 0 }}
                onClick={() => {
                  setIsPageIncrement(false);
                  filterProps?.setPage((_prev) => 1);
                  filterProps?.setSort(prev => prev === "ASC" ? "DESC" : "ASC")
                }}
              >
                {filterProps?.sort === "ASC"  && (
                  <ArrowUpIcon
                  className="h-5 w-5 text-black}"
                />
                )}
                {filterProps?.sort === "DESC"  && (
                  <ArrowDownIcon
                  className="h-5 w-5 text-black}"
                />
                )}
              </Button>
              {filters?.length > 0 && (
                <Select 
                  value={filterProps?.sortField} 
                  onValueChange={(val: any) => {
                    setIsPageIncrement(false);
                    filterProps?.setPage((_prev) => 1);
                    filterProps?.setSortField((_prev) => val);
                  }}
                >
                  <SelectTrigger className='bg-[#F4F4F5] border-none cursor-pointer p-2 truncate text-xs text-[#09090B] outline-none ring-0 focus:ring-0' >
                    <SelectValue placeholder="Select Filter" />
                  </SelectTrigger>
                  <SelectContent align='end' className='border-0 text-xs'>
                    {filters.map(filter => (
                      <SelectItem key={filter?.label} value={filter?.value} className='cursor-pointer text-[#505056]'>{filter?.label || ''}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}
            </div>
          </div>
          <div className="h-full overflow-y-auto">
            {memberList?.length > 0 && !memberListLoading ? (
              <ScrollArea className="w-full h-full flex flex-col">
                <div className="flex flex-col gap-2  max-w-[318px]">
                  {memberList.map((member) => (
                    <MemberItem
                      key={member.user_id}
                      member={member}
                      workspaceUsersObj={workspaceUsersObj}
                      insightsFilters={insightsFilters}
                      handleLeaderboardUserClick={handleLeaderboardUserClick}
                      handleLeaderboardUserRemove={handleLeaderboardUserRemove}
                    />
                  ))}
                  {isPageIncrement && memberListLoading ? (
                    <Loader2 className='text-[#2BFFFF] animate-spin'/>
                  ) : (
                    <>
                      {!noDataFetch && memberList?.length >= 10 &&(
                        <Button
                          variant="outline"
                          className="w-[150px] mx-auto border border-[#2BFFFF] text-[#2BFFFF] bg-transparent hover:bg-transparent p-3 cursor-pointer rounded-full hover:text-[#2BFFFF] h-fit"
                          onClick={() => {
                            setIsPageIncrement(true);
                            filterProps.setPage((prev: number) => prev + 1)
                          }}
                        >
                          Load More
                        </Button>
                      )}
                    </>
                  )}
                </div>
              </ScrollArea>
            ) : (
              <>
                {memberListLoading && !isPageIncrement ? (
                  <div className="flex flex-col gap-2 w-full">
                    <MemberItemLoader />
                    <MemberItemLoader />
                    <MemberItemLoader />
                  </div>
                ) : (
                  <div className="flex flex-col gap-2 w-full">
                    No Members
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

export default TeamMemberList